import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

/** Tiền VND đầy đủ: 1.234.567 đ — số luôn dùng tabular-nums ở chỗ hiển thị. */
export const formatVND = (n: number): string => `${Math.round(n) < 0 ? '−' : ''}${Math.abs(Math.round(n)).toLocaleString('vi-VN')} đ`;

/** Rút gọn cho chỗ hẹp: 1,2 tr · 3,4 tỷ · 450k. */
export const formatCompact = (n: number): string => {
  const a = Math.abs(n), sign = n < 0 ? '−' : '';
  const f = (x: number, u: string) => `${sign}${(Math.round(x * 10) / 10).toLocaleString('vi-VN')} ${u}`;
  if (a >= 1e9) return f(a / 1e9, 'tỷ');
  if (a >= 1e6) return f(a / 1e6, 'tr');
  if (a >= 1e3) return `${sign}${Math.round(a / 1e3).toLocaleString('vi-VN')}k`;
  return `${sign}${Math.round(a)} đ`;
};
